import axios from 'axios';
import { verificaParametroDaUrl } from 'utils/verify-url-params';
export function verificaLoginZendesk() {
  const valorLoginZendesk = verificaParametroDaUrl('loginZendesk');
  return valorLoginZendesk;
}

export async function gerarTokenZendesk(): Promise<any> {
  const res = await axios.get(
    `${process.env.REACT_APP_USER_SESSION_API}/bolsas/zendesk/token`,
    {
      headers: { Authorization: `${localStorage.getItem('tokenIES')}` },
    },
  );
  return res.data.token;
}

export async function gerarTokenChatZendesk(): Promise<any> {
  const res = await axios.get(
    `${process.env.REACT_APP_USER_SESSION_API}/bolsas/chat-zendesk/token`,
    {
      headers: { Authorization: `${localStorage.getItem('tokenIES')}` },
    },
  );
  return res.data.token;
}

export function gerarZendeskRedirectUrl(tokenZendesk) {
  let zendeskUrl = `${process.env.REACT_APP_ZENDESK_JWT_ACCESS}?jwt=${tokenZendesk}`;
  const valorReturnTo = verificaParametroDaUrl('return_to');

  if (valorReturnTo) {
    zendeskUrl += `&return_to=${valorReturnTo}`;
  }

  return zendeskUrl;
}
